import { Mail, Heart, Instagram, Facebook, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      style={{ background: "var(--blush)", color: "#FAF9F6" }}
      className="pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="font-serif-display text-3xl">Nourished Nest</span>
              <span
                className="text-[10px] tracking-[0.32em] uppercase pl-2 border-l"
                style={{ borderColor: "rgba(250,249,246,0.6)" }}
              >
                Doula
              </span>
            </div>
            <p className="mt-5 max-w-md leading-relaxed text-[15px]" style={{ opacity: 0.9 }}>
              Gentle postpartum care across Greater Brisbane — tending to mother, baby and the whole family
              through the tender weeks after birth.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.28em] mb-4" style={{ opacity: 0.75 }}>
              Explore
            </div>
            <ul className="space-y-3 text-sm">
              <li><a href="#about" className="hover:underline">About</a></li>
              <li><a href="#services" className="hover:underline">Services</a></li>
              <li><a href="#meet-monica" className="hover:underline">Meet Monica</a></li>
              <li><a href="#testimonials" className="hover:underline">Testimonials</a></li>
              <li><a href="#faq" className="hover:underline">FAQ</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.28em] mb-4" style={{ opacity: 0.75 }}>
              Get in touch
            </div>
            <a
              href="mailto:monica@nourishednestdoula.com"
              className="flex items-center gap-3 text-sm hover:underline"
              data-testid="footer-email"
            >
              <Mail size={16} /> monica@nourishednestdoula.com
            </a>
            <a
              href="https://www.nourishednestdoula.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-sm hover:underline mt-2"
              data-testid="footer-website"
            >
              <Globe size={16} /> www.nourishednestdoula.com
            </a>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://instagram.com/nourished_nest_doula"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram @nourished_nest_doula"
                title="@nourished_nest_doula"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-transform hover:scale-110"
                style={{ background: "rgba(250,249,246,0.15)" }}
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://facebook.com/nourishednestdoulaservices"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook @nourishednestdoulaservices"
                title="@nourishednestdoulaservices"
                data-testid="footer-facebook"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-transform hover:scale-110"
                style={{ background: "rgba(250,249,246,0.15)" }}
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>
        </div>

        <div
          className="mt-14 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs"
          style={{ borderTop: "1px solid rgba(250,249,246,0.25)", opacity: 0.85 }}
        >
          <p>© {new Date().getFullYear()} Nourished Nest Doula. All rights reserved.</p>
          <p className="flex items-center gap-1.5">
            Made with <Heart size={12} /> for new families
          </p>
        </div>
      </div>
    </footer>
  );
}
